<template>
  <div class="email-window">
    <table class="main-table">
      <tr v-if="type === '1'">
        <td style="width:80px;">&nbsp;</td>
        <td>
          <el-radio-group v-model="type">
            <el-radio-button label="0">同事</el-radio-button>
            <el-radio-button label="1">客户</el-radio-button>
          </el-radio-group>
        </td>
      </tr>
      <tr v-if="type === '0'">
        <td class="label">收件人:</td>
        <td>
          <el-checkbox-group v-model="checkedUsers">
            <el-checkbox v-for="item in userList" :key="item.id" :label="item.id">{{ item.realname }}</el-checkbox>
          </el-checkbox-group>
        </td>
      </tr>
      <tr v-if="type === '1'">
        <td class="label">仅发送给:</td>
        <td>
          <div flex>
            <div class="customer-card" style="width:300px">
              <div class="title">Country</div>
              <div class="content">
                <el-checkbox-group v-model="searchForm.countries" @change="searchContact">
                  <el-checkbox v-for="item in countryList" :key="item.country" :label="item.country">{{ item.country }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div class="customer-card" style="width:120px">
              <div class="title">Supplier/Buyer</div>
              <div class="content">
                <el-checkbox-group v-model="searchForm.type_2s" @change="searchContact">
                  <el-checkbox label="Supplier"></el-checkbox>
                  <el-checkbox label="Buyer"></el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div class="customer-card" style="width:260px">
              <div class="title">Customer Class</div>
              <div class="content">
                <el-checkbox-group v-model="searchForm.classes" @change="searchContact">
                  <el-checkbox v-for="item in categoryList" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
            <div class="customer-card" flex-box="1">
              <div class="title">Customer Group</div>
              <div class="content">
                <el-checkbox-group v-model="searchForm.group_ids" @change="searchContact">
                  <el-checkbox v-for="item in companyGroupList" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr v-if="type === '1'">
        <td class="label">收件人列表:</td>
        <td>
          <div class="customer-card">
            <div class="title">请勾选收件人</div>
            <div class="content">
              <div v-if="contactList.length > 0">
                <table>
                  <tr>
                    <th>
                      &nbsp;
                    </th>
                    <th>Company Name</th>
                    <th>Contact Name</th>
                    <th>Email</th>
                  </tr>
                  <tr v-for="item in contactList" :key="item.id">
                    <td>
                      <input type="checkbox" :id="'contact_' + item.id" :value="item.email" v-model="checkedContactEmails">
                    </td>
                    <td>{{ item.company_name }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.email }}</td>
                  </tr>
                </table>
              </div>
              <div v-else>没有找到符合条件的联系人</div>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <td class="label">主题:</td>
        <td>
          <el-input v-model="form.subject" style="width:100%"></el-input>
        </td>
      </tr>
      <tr>
        <td style="padding-bottom:0;">&nbsp;</td>
        <td style="padding-bottom:0;">
          <el-button type="primary" @click="send" :loading="sending">发送邮件</el-button>
        </td>
      </tr>
      <tr>
        <td class="label">邮件正文:</td>
        <td>
          <editor v-model="form.html" :init="editorInit"></editor>
        </td>
      </tr>
      <tr>
        <td style="padding-top:0;">&nbsp;</td>
        <td style="padding-top:0;">
          <el-button type="primary" @click="send" :loading="sending">发送邮件</el-button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import qs from 'qs'
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver';
// Any plugins you want to use has to be imported
//import 'tinymce/plugins/wordcount';
//import 'tinymce/plugins/link';
import Editor from '@tinymce/tinymce-vue'
export default {
  components: {
    Editor
  },
  data () {
    return {
      form: {
        id: 0,
        to: '',
        subject: '',
        html: ''
      },
      searchForm: {
        countries: ['China', 'Hongkong', 'Japan', 'United States'],
        type_2s: ['Buyer'],
        classes: [1, 2],
        group_ids: [],
        is_key: '1'
      },
      type: this.$route.query.type || '0',
      userList: [],
      checkedUsers: [],
      sending: false,
      editorInit: {
        skin_url: '/skins/ui/oxide',
        height: 500
      },
      countryList: [],
      contactList: [],
      checkedContactEmails: []
    }
  },
  computed: {
    categoryList () {
      return this.$store.state.select.category
    },
    companyGroupList () {
      return this.$store.state.select.company_group
    }
  },
  mounted () {
    this.fetch()
    this.fetchUsers()
    this.fetchCountries()
    this.searchContact()
    this.$store.dispatch('fetchSelect', 'category')
    this.$store.dispatch('fetchSelect', 'company_group')
  },
  methods: {
    fetch () {
      this.$http.get('/dbapi/email_outbox?id=' + this.$route.params.id).then(data => {
        if (data.list.length > 0) {
          this.form.id = data.list[0].id
          this.form.subject = data.list[0].subject
          this.form.html = data.list[0].html
        }
      })
    },
    fetchUsers () {
      this.$http.get('/dbapi/user_list?has_email=1').then(data => {
        this.userList = data.list
      })
    },
    fetchCountries () {
      this.$http.get('/dbapi/company_countries').then(data => {
        this.countryList = data.list
      })
    },
    searchContact () {
      let params = { ...this.searchForm }
      this.$http.get('/dbapi/company_contact_list', {
        params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }).then(data => {
        this.contactList = data.list
      })
    },
    send () {
      let arr = []
      if (this.type === '0') {
        if (this.checkedUsers.length === 0) {
          this.$message({
            type: 'error',
            message: '请选择收件人'
          })
          return
        }
        arr = this.userList.filter(u => this.checkedUsers.indexOf(u.id) >= 0).map(r => r.email)
      } else {
        if (this.checkedContactEmails.length === 0) {
          this.$message({
            type: 'error',
            message: '请选择收件人'
          })
          return
        }
        arr = checkedContactEmails
      }
      this.sending = true
      // this.form.to = arr.join(',')
      this.$http.post('/api/mail-update', {
        id: this.form.id,
        to: arr,
        subject: this.form.subject,
        html: this.form.html
      }).then(result => {
        return this.$http.post('/api/mail-send', { id: this.$route.params.id })
      }).then(result => {
        this.sending = false
        this.$alert('邮件发送成功', '发送成功', {
          confirmButtonText: '关闭窗口',
          callback: action => {
            window.close()
          }
        })
      }).catch(() => this.sending = false)
    }
  }
}
</script>

<style lang="scss">
.email-window {
  .main-table {
    width: 100%;
    border-spacing: 0;
    border: 0;
    td {
      padding: 6px;
      &.label {
        text-align: right;
        vertical-align: top;
      }
    }
  }
  .el-checkbox+.el-checkbox {
    margin-left: 0!important;
  }
  .el-checkbox {
    margin-right: 10px;
  }
  .customer-card {
    background-color: #fff;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    .title {
      background-color: #ddd;
      font-weight: bold;
      padding: 4px;
      margin-bottom: 4px;
    }
    .content {
      padding: 6px;
      height: 100px;
      overflow-y: auto;
    }
  }
  .customer-card+.customer-card {
    margin-left: 10px;
  }
}
.tox-notifications-container {
  display: none;
}
</style>
